// 
import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/serviceOrder',
    name: 'serviceOrder',
    meta: {
      title: '音频娱乐订单',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/serviceOrder/index.vue'),
  },
  {
    path: '/serviceOrder/detail',
    name: 'serviceOrderDetail',
    meta: {
      title: '订单详情',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/serviceOrder/detail.vue'),
  },
]

export default routes
